import Link                  from 'scripts/defa/application/application-link';
import BaseController        from 'scripts/defa/application/controller-base-controller';
import BaseRouter            from 'scripts/defa/application/router-base-router';
import LayoutHandler         from 'scripts/defa/application/service-layout-handler';
import NavHandler            from 'scripts/defa/application/service-nav-handler';
import PageVisibilityHandler from 'scripts/defa/application/service-page-visibility-handler';
import UserHandler           from 'scripts/defa/application/service-user-handler';
import CheatView             from 'scripts/defa/application/view-cheat-view';
import Root                  from 'scripts/defa/application/view-root-view';
import Module                from 'scripts/module';

const ApplicationModule = new Module('ApplicationModule', {
	applications: {
		Link
	},
	controllers: {
		BaseController
	},
	routers: {
		BaseRouter
	},
	services: {
		LayoutHandler,
		NavHandler,
		PageVisibilityHandler,
		UserHandler
	},
	views: {
		CheatView,
		Root
	}
});

export default ApplicationModule